import React, { useState } from 'react';
import './deleteWifiDot.css';
import axiosInstance from '../../../utils/router/axiosInstance';
import { logger } from '../../../utils/logger';

const ModalDeleteWifiDot = ({ setIsModalActive, bssids, onDelete }) => {
  const [confirmation, setConfirmation] = useState('');
  const [confirmed, setConfirmed] = useState(false);

  const handleConfirmationChange = (e) => {
    setConfirmation(e.target.value);
    setConfirmed(e.target.value.toLowerCase() === 'удалить');
  };

  const handleDelete = async () => {
    if (confirmed) {
      const deletePromises = bssids.map((bssid) =>
        axiosInstance
          .delete(`website/dots/${bssid}`)
          .then((response) => {
            logger.debug(`BSSID ${bssid} deleted successfully`);
          })
          .catch((error) => {
            logger.error(`Error deleting BSSID ${bssid}:`, error);
          })
      );

      await Promise.all(deletePromises)
        .then(() => {
          onDelete(); // Вызываем callback-функцию после удаления всех элементов
        })
        .catch((error) => {
          logger.error('Error deleting some BSSIDs:', error);
        });

      setIsModalActive(false);
    }
  };

  return (
    <div className="UserDelete">
      <p className="DeleteInfo">ВНИМАНИЕ!</p>
      <p className="DeleteInfo">Если вы удалите точку доступа, то вся информация о ней будет удалена</p>
      <p className="DeleteInfo">Введите слово "Удалить" для подтверждения удаления:</p>
      <input className="DeleteInput" type="text" value={confirmation} onChange={handleConfirmationChange} />
      <button className="DeleteBTN" onClick={handleDelete} disabled={!confirmed}>
        Удалить
      </button>
    </div>
  );
};

export default ModalDeleteWifiDot;
